import 'react-dom';

import ProtectionsActions from 'protections/actions/protectionsActions.js';
import ProtectionsActionsTypes from 'protections/actions/protectionsActionTypes.js';

import Protections from 'protections/containers/Protections/Protections.js';
import ProtectionsProvider from 'protections/ProtectionsProvider.jsx';

import ProtectionsReducer from 'protections/reducers/protectionsReducer.js';

import en from 'protections/i18n/en.json';
import fr from 'protections/i18n/fr.json';

const Translations = { en, fr };
const root = Protections;
const provider = ProtectionsProvider;
const main = provider;

export const widgets = {
    Protections: {
        components: {
            root,
            provider,
            main,
        },

        ProtectionsActions,
        ProtectionsActionsTypes,
        ProtectionsReducer,

        Translations,
    },
};

export default {
    root,
    provider,
    Protections: main,

    ProtectionsActions,
    ProtectionsActionsTypes,
    ProtectionsReducer,

    Translations,
};



// WEBPACK FOOTER //
// ./src/index.js